// Ironic one-liner shown under the reached island (result card + share image). Edit freely.
export const DESTINATION_QUOTES = {
  "East Blue": "Avventura breve. Molto breve.",
  "Reverse Mountain": "La corrente saliva. La ciurma no.",
  "Whisky Peak": "Accoglienza calorosa, conto salatissimo.",
  "Little Garden": "Due giganti litigano da 100 anni. Voi avete litigato per la rotta.",
  Drum: "Almeno il medico l'avete trovato. Forse.",
  Alabasta: "Tanta sabbia, poche idee.",
  Jaya: "Vi hanno detto che il cielo era un mito. Ci avete creduto.",
  Skypiea: "Toccato il cielo con un dito. Poi la gravità.",
  "Long Ring Long Land": "Avete perso a un gioco. Letteralmente.",
  "Water 7": "La nave non ce l'ha fatta. E nemmeno voi.",
  "Enies Lobby": "Il Governo Mondiale può dormire relativamente tranquillo.",
  "Thriller Bark": "Avete perso l'ombra. E la direzione.",
  Sabaody: "Rivestimento della nave in corso… da due anni.",
  "Isola degli Uomini-Pesce": "Diecimila metri sotto il mare, zero sopra le aspettative.",
  "Punk Hazard": "Metà fuoco, metà ghiaccio, tutta confusione.",
  Dressrosa: "Ottimo Colosseo. Pessimo epilogo.",
  Zou: "Siete saliti su un elefante. Il resto è storia breve.",
  "Whole Cake Island": "Fermati dal dessert. Nessuna vergogna.",
  Wano: "Ciurma forte. Samurai più forti.",
  Egghead: "Il futuro era lì. Voi un po' meno.",
  Elbaph: "I giganti vi hanno guardato con rispetto. Quasi.",
  Lodestar: "A un passo dalla leggenda. Un passo enorme.",
  "Laugh Tale": "Okay. Questa ciurma ha trovato il One Piece prima di noi.",
};
